if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        this.skipCart =
          this.form.querySelector('[name=id]')?.dataset.skipCart === 'true';

        // Celebrate only when this add fills a previously empty cart.
        window.__plCartConfettiPending = Boolean(
          !this.skipCart && this.cart && this.cart.classList.contains('is-empty')
        );

        // Open drawer immediately when it already has items — feels instant while the request runs.
        if (
          this.cart &&
          !this.skipCart &&
          !this.cart.classList.contains('is-empty') &&
          typeof this.cart.open === 'function'
        ) {
          this.cart.setActiveElement(document.activeElement);
          this.cart.open(this.submitButton);
        }
        const plDrawerUpdateStarted = Boolean(
          !this.skipCart &&
          this.cart &&
          this.cart.tagName === 'CART-DRAWER' &&
          !this.cart.classList.contains('is-empty')
        );
        if (plDrawerUpdateStarted && window.plCartDrawerUpdateStart) {
          window.plCartDrawerUpdateStart();
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const prepareCart = this.skipCart
          ? fetch(`${routes.cart_url}/clear.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          : this.upsellVariantId
            ? window.__plCart && typeof window.__plCart.item_count === 'number'
              ? Promise.resolve(window.__plCart)
              : fetch(`${routes.cart_url}.js`).then((response) => response.json())
            : Promise.resolve();

        prepareCart
          .then((result) => {
            if (!this.skipCart && result?.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            if (this.skipCart) return this.addVolumeOrForm(formData, config);
            return this.addOrReplaceProduct(formData, config);
          })

          .then((response) => {
            if (response && typeof response.json === 'function') return response.json();
            return response;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open(this.submitButton);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            if (response && Array.isArray(response.items) && response.item_count != null) {
              window.__plCart = response;
            } else {
              window.__plCart = null;
            }

            const showCart = () => {
              const drawerItems = document.querySelector('cart-drawer-items');
              if (
                response &&
                response.plFastQtyUpdate &&
                drawerItems &&
                typeof drawerItems.syncFromCart === 'function'
              ) {
                drawerItems.syncFromCart(response);
                if (typeof this.cart.open === 'function') this.cart.open(this.submitButton);
                return;
              }
              try {
                this.cart.renderContents(response);
              } catch (err) {
                console.error(err);
                if (typeof this.cart.open === 'function') this.cart.open();
              }
            };

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(showCart);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              showCart();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (plDrawerUpdateStarted && window.plCartDrawerUpdateEnd) {
              window.plCartDrawerUpdateEnd();
            }
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      addVolumeItems(items, formData) {
        const payload = {
          items: items.map((item) => ({
            id: Number(item.id),
            quantity: Math.max(1, parseInt(item.quantity, 10) || 1),
          })),
        };
        const sections = formData.get('sections');
        if (sections) payload.sections = String(sections).split(',');
        const sectionsUrl = formData.get('sections_url');
        if (sectionsUrl) payload.sections_url = sectionsUrl;
        return fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify(payload),
        });
      }

      addVolumeOrForm(formData, config) {
        const lineItems = typeof window.plVolumeGetLineItems === 'function' ? window.plVolumeGetLineItems() : null;
        if (lineItems && lineItems.length) return this.addVolumeItems(lineItems, formData);
        return fetch(`${routes.cart_add_url}`, config);
      }

      addOrReplaceProduct(formData, config) {
        // Always append — never clear/replace existing cart lines from the PDP.
        return this.addVolumeOrForm(formData, config);
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
